// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"ea299a45","453":"b0833b34","486":"85cdf1b4"}[chunkId] + ".chunk.js";
};